const { Mark } = Statamic.$bard.tiptap.core;

export const Hyphenate = Mark.create({
    name: 'hyphenate',

    renderHTML() {
        return ['span', { 'class': 'hyphenate' }, 0];
    },

    addCommands() {
        return {
            setHyphenation: attributes => ({ chain }) => {
                return chain().toggleMark(this.name, attributes).run();
            },
        };
    },
});